import {useMutation, useQueryClient} from "@tanstack/react-query";
import {toast} from "react-toastify";
import {update} from "../../../app/setters/update.js";
import {useNavigate} from "react-router-dom";

export const useZlozHarm = () => {
const navigate = useNavigate();

    const queryClient = useQueryClient();

    return useMutation({
        mutationFn: (data) => update(`/plan-harm/zloz`, data),
        onSettled: async () => {
            await queryClient.invalidateQueries({
                predicate: query => query.queryKey[0].startsWith(`lista_projektow__/rejestr/lista`),
            });
        },
        onSuccess: ({message}) => {
            toast.success(message)
            navigate(-1)
        },
    });
};
